/** Индекс вкладки «Отчёты» в `.personal-area` (TabWidget). */
export const RESIDENT_LK_REPORTS_TAB_ID = 1;

export function getReportIdFromUrl(locationLike: Pick<Location, 'pathname' | 'search'> = window.location): number | null {
  const pathMatch =
    locationLike.pathname.match(/\/lk\/resident\/report\/(\d+)\/?$/i) ??
    locationLike.pathname.match(/\/report\/(\d+)\/?$/i);
  if (pathMatch) {
    return Number(pathMatch[1]);
  }

  const params = new URLSearchParams(locationLike.search);
  const id = params.get('Id') ?? params.get('id');
  if (id && /^\d+$/.test(id)) {
    return Number(id);
  }

  return null;
}

export function getReportDetailHref(id: number): string {
  return `/lk/resident/report/${id}/?tab=${RESIDENT_LK_REPORTS_TAB_ID}`;
}

export function getReportListHref(): string {
  return `/lk/resident/?tab=${RESIDENT_LK_REPORTS_TAB_ID}`;
}

export function navigateToReportList(): void {
  window.location.replace(getReportListHref());
}

export function getReportEditHref(id: number): string {
  return `/lk/resident/reports/?Id=${id}`;
}
